import React from 'react';

import SmartLink from '../components/Common/SmartLink';
import * as ds from '../components/Layouts/Header/DesktopStyles.module.scss';
import * as styles from '../components/Layouts/Header/Header.module.scss';
import SubMenu from '../components/Layouts/Header/SubMenu';

export default function navBuilder(item, i) {
  return (
    <li
      data-analytics-component={`header-subnav`}
      data-analytics-id={item.title}
      key={`${item.title}-${i}`}
      className={[styles.menuItem, ds.menuItem].join(' ')}
    >
      {item.url ? (
        <SmartLink
          rel={item.isNoFollow ? 'nofollow' : ''}
          className={[styles.menuItemLink, ds.menuItemLink].join(' ')}
          to={item.url}
        >
          {item.title}
        </SmartLink>
      ) : (
        <button className={[styles.menuItemLink, ds.menuItemLink].join(' ')}>
          <label>
            {item.titleUrl ? (
              <SmartLink className={styles.highLevelLink} to={item.titleUrl}>
                {item.title}
              </SmartLink>
            ) : (
              item.title
            )}
          </label>
          {item.menuItems && (
            <div className={styles.subNav}>
              <SubMenu menu={item} />
            </div>
          )}
        </button>
      )}
    </li>
  );
}
